<div class="modal-body wre-modal-body">
    <div class="d-flex align-items-center justify-content-center">
        <div class="loading" *ngIf="loading"></div>
    </div>
    <div class="row" *ngIf="!loading">
        <div class="form-group col-12 w-100 mb-0">
            <label class="form-control-label">User Lookup</label>
            <wre-user-lookup-multiselect class="w-100" inputId="reviewers" inputName="reviewers"
                allowOnlyInternalUsers="true" [control]="form.get('reviewers')" [useFriendlyDisplayName]="true"
                [isInvalid]="form.get('reviewers').errors?.noReviewersProvided" [distributionListsIncluded]="false"
                placeholderValue="Search user...">
            </wre-user-lookup-multiselect>
        </div>
    </div>
</div>